import { Button, Input, useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { ModelState } from 'BrokerTsLib/src/dtos'
import { BadRequestError } from 'BrokerTsLib/src/dtos'
import { appendToFormData } from 'BrokerTsLib/src/hooks'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { setModelStateErrors } from 'BrokerTsLib/src/Utils/formModelState'
import { useRef } from 'react'

import type { PpzAuthorizationAddFiles } from '@/dtos'
import { useAddFiles } from '@/hooks/usePpzAuthorization'
import { Upload } from '@/icons'

export const PpzAuthorizationAddFilesForm = ({ ppzAuthorizationId }: { ppzAuthorizationId: number }) => {
  const { mutateAsync: addFilesAsync } = useAddFiles(ppzAuthorizationId)

  const toast = useToast()
  const form = useForm<PpzAuthorizationAddFiles>({
    defaultValues: {
      id: ppzAuthorizationId
    },
    reValidateMode: 'onChange',
    mode: 'all'
  })
  const { handleSubmit, setError, formState: { isSubmitting }, register, reset } = form
  const formRef = useRef<HTMLFormElement>(null)

  const submitHandler = async (data: PpzAuthorizationAddFiles) => {
    const formData = new FormData(formRef.current!)
    appendToFormData(formData, data)
    await addFilesAsync(formData)
      .then((response) => {
        toast({
          title: 'Soubořy byly úspěšně přidány.',
          status: 'success'
        })

        reset()
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 400)
          setModelStateErrors(setError, new BadRequestError(e.response.data as ModelState<PpzAuthorizationAddFiles>))
        else
          toast({
            title: 'Chyba při přidávání souborů.',
            status: 'error'
          })
      })
  }

  return (
    <FormProvider {...form}>
      <form ref={formRef} onSubmit={handleSubmit(submitHandler)}>
        <Input display='none' type="file" multiple id="filesInput" {...register('files')} onChange={handleSubmit(submitHandler)} />
        <Button as="label" display='flex' gap={4} justifySelf='start' isLoading={isSubmitting} onClick={() => document.getElementById('filesInput')?.click()} >
          <Upload color="secondary.500" />
          Vybrat soubory
        </Button>
      </form>
    </FormProvider>
  )
}